import React, { RefObject } from 'react';
import { Button as BaseButton, ButtonProps } from '@cp/ds/src/components/button';
import { FilterIcon } from '@cp/ds/src/icons/filter';
import { Box } from '@cp/ds/src/components/box';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { useIsStandalone } from 'src/shared/mediaQueries';
import { withTrackClick } from 'src/shared/tracking';
import { useInView } from 'src/app/shared/hooks/useInView';
import { useCatalogFilterOpen } from '../model';
import { CatalogEvents } from '../events';

const Button = withTrackClick(BaseButton, CatalogEvents.FilterOpen);

interface FilterButtonProps extends ButtonProps {
  wrap?: RefObject<HTMLElement | null>;
}

export const CatalogFilterOpenButton: React.FC<FilterButtonProps> = ({ sx, wrap, ...props }) => {
  const open = useCatalogFilterOpen();
  const isStandalone = useIsStandalone();
  const isInView = useInView(wrap, {
    root: null,
    rootMargin: '0px 0px -95% 0px',
    threshold: 0,
  });

  if (!isInView) {
    return null;
  }

  return (
    <Box sx={mergeSx({ position: 'fixed', bottom: isStandalone ? 100 : 80, left: '50%' }, sx)}>
      <Button
        color="gray"
        iconRight={<FilterIcon />}
        onClick={open}
        size="small"
        sx={{ transform: 'translateX(-50%)', border: '2px solid white', boxShadow: '0 0 16px #00000038' }}
        {...props}
      >
        Фильтр
      </Button>
    </Box>
  );
};
